import React from "react";
import { TemplatePanel } from "./TemplatePanel";
import { DefaultRouteParam, StorageProviderRouteParam } from "constants/routes";
import { useParams } from "react-router-dom";

export interface ITemplatePanelContainerProps {
  isReadonly?: boolean;
  onClose: () => void;
}

export const TemplatePanelContainer = ({
  isReadonly,
  onClose,
}: ITemplatePanelContainerProps) => {
  const { idOrAction } = useParams<{
    [DefaultRouteParam.IdOrAction]: string;
  }>();
  return (
    <TemplatePanel
      isOpen={idOrAction == StorageProviderRouteParam.Template}
      onClose={onClose}
      isReadonly={isReadonly}
    />
  );
};
